"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (application) => `mutation sendChatMessage ($receiver: Int, $text: String, $attachmentMediaId: ID, $type: String) {
${application == "PBP"
    ? "sendChatMessage"
    : "sendChatMessage: sendPmpChatMessage"}(receiver: $receiver, text: $text, attachmentMediaId: $attachmentMediaId, type: $type) {
                            chatMessage {
                                id
                            }
                        }
                    }`;
//# sourceMappingURL=sendChatMessageFactory.js.map